import "./App.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import { BrowserRouter as Router } from "react-router-dom";
import { useSelector } from "react-redux";

// redux auth
import {
  selectIsLoggedIn,
  selectScholarshipId,
  selectScholarshipIsActive,
  selectScholarshipType,
} from "../../utils/auth/authSlice";
// redux auth
// import { selectScholarshipId } from "../../utils/scholarship/scholarshipSlice";

// routing
import { getRoutes } from "../../routes/routes";

export default function App() {
  // TODO: Make document.title dynamic
  document.title = "UGGLA Family Scholarship";
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const scholarshipId = useSelector(selectScholarshipId);
  const isActive = useSelector(selectScholarshipIsActive);
  const scholarshipType = useSelector(selectScholarshipType);
  if (scholarshipType === "fas-scholarship") {
    document.title = "FAS Scholarship";
  }

  const routes = getRoutes(
    isLoggedIn,
    scholarshipId,
    isActive,
    scholarshipType
  );

  return (
    <>
      <div className="App">
        <Router>{routes}</Router>
      </div>
    </>
  );
}
